import { gql } from '@apollo/client';
import { QUOTE_CALC_VIEW_MODEL_FRAGMENT } from './fragments';

export const QUOTE_CALC_PREVIEW = gql`
  query QuoteCalcPreview($input: QuoteCalcPreviewInput!) {
    quoteCalc {
      result: preview(input: $input) {
        error
        success
        entity {
          ...QuoteCalcViewModelFields
        }
      }
    }
  }
  ${QUOTE_CALC_VIEW_MODEL_FRAGMENT}
`;
